// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__HNKcm","title":"Item_title__1UVma","container":"Item_container__hUJhH"};